import {AdminAxios} from "../../common/Axios";

const USER_CATEGORY_URL = "/media/user-category";

const getResponseMessage = (source, fallbackMessage) => {
  const responseBody = source?.response?.data ?? source;
  return responseBody?.message
    ?? responseBody?.data?.message
    ?? responseBody?.responseCode?.message
    ?? responseBody?.responseMessage
    ?? responseBody?.errorMessage
    ?? fallbackMessage;
};

const normalizeCategory = category => ({
  id: category.id,
  value: category.code ?? category.value ?? "",
  label: category.name ?? category.label ?? "",
  description: category.description ?? "",
  examples: category.examples ?? "",
});

const toRequest = category => ({
  ...(category.id ? {id: category.id} : {}),
  code: category.value,
  name: category.label,
  description: category.description,
  examples: category.examples,
});

export async function selectUserCategories() {
  const response = await AdminAxios("GET", USER_CATEGORY_URL);
  if (response?.statusCode !== 200) throw new Error("카테고리 목록을 불러오지 못했습니다.");
  const rows = Array.isArray(response.data) ? response.data : response.data?.rows;
  return Array.isArray(rows) ? rows.map(normalizeCategory) : [];
}

export async function createUserCategory(category) {
  const response = await AdminAxios("POST", USER_CATEGORY_URL, toRequest(category));
  if (![200, 201].includes(response?.statusCode)) throw new Error("카테고리를 등록하지 못했습니다.");
  return response.data ? normalizeCategory(response.data) : true;
}

export async function updateUserCategory(category) {
  const response = await AdminAxios("PUT", `${USER_CATEGORY_URL}/${category.id}`, toRequest(category));
  if (response?.statusCode !== 200) throw new Error("카테고리를 수정하지 못했습니다.");
  return response.data ? normalizeCategory(response.data) : true;
}

export async function deleteUserCategory(categoryId) {
  const fallbackMessage = "카테고리를 삭제하지 못했습니다.";
  try {
    const response = await AdminAxios("DELETE", `${USER_CATEGORY_URL}/${categoryId}`);
    if (![200, 204].includes(response?.statusCode)) {
      throw new Error(getResponseMessage(response, fallbackMessage));
    }
    return true;
  } catch (error) {
    throw new Error(getResponseMessage(error, error?.message || fallbackMessage));
  }
}
